import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const NavigateToBoardDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NavigateToBoardData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shortLink"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"NavigateToBoardData","document":NavigateToBoardDataDocument}} as const;
export type NavigateToBoardDataQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID']['input'];
}>;


export type NavigateToBoardDataQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'shortLink' | 'name'>
  )> }
);

/**
 * __useNavigateToBoardDataQuery__
 *
 * To run a query within a React component, call `useNavigateToBoardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigateToBoardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigateToBoardDataQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useNavigateToBoardDataQuery(
  baseOptions: TrelloQueryHookOptions<
    NavigateToBoardDataQuery,
    NavigateToBoardDataQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: NavigateToBoardDataDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    NavigateToBoardDataQuery,
    NavigateToBoardDataQueryVariables
  >(NavigateToBoardDataDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useNavigateToBoardDataLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    NavigateToBoardDataQuery,
    NavigateToBoardDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NavigateToBoardDataQuery,
    NavigateToBoardDataQueryVariables
  >(NavigateToBoardDataDocument, options);
}
export type NavigateToBoardDataQueryHookResult = ReturnType<
  typeof useNavigateToBoardDataQuery
>;
export type NavigateToBoardDataLazyQueryHookResult = ReturnType<
  typeof useNavigateToBoardDataLazyQuery
>;
export type NavigateToBoardDataQueryResult = Apollo.QueryResult<
  NavigateToBoardDataQuery,
  NavigateToBoardDataQueryVariables
>;
